import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 loader + SPA page-view tracker.
 *
 * Only activates when REACT_APP_GA_MEASUREMENT_ID is set (starts with "G-").
 * If unset, this component is a no-op — perfect for dev / preview.
 *
 * Fires a `page_view` on every route change so client-side navigation
 * is counted correctly (default GA snippet only tracks the first load).
 */
export default function GoogleAnalytics() {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    const location = useLocation();

    // Inject the gtag.js script once on mount
    useEffect(() => {
        if (!measurementId || !measurementId.startsWith("G-")) return;
        if (document.getElementById("ga4-loader")) return;

        const script = document.createElement("script");
        script.id = "ga4-loader";
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        // send_page_view=false — we fire manually per route change below
        gtag("config", measurementId, { send_page_view: false });
    }, [measurementId]);

    // Fire a page_view on every route change
    useEffect(() => {
        if (!measurementId || typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location, measurementId]);

    return null;
}
